import { render, staticRenderFns } from "./CollectionItemStaffList.vue?vue&type=template&id=5a10b879&"
import script from "./CollectionItemStaffList.vue?vue&type=script&lang=js&"
export * from "./CollectionItemStaffList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemStaffList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports